import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompBottom({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] =useState('Guardar Informacion')
  const [infoBottomComponent, setInfoCompBottom] = useState({
    Axle_Dust_Covers: 0,
    Axial_Dust_Covers: 0,
    Scissors: 0,
    Scissor_Bushings: 0,
    Stabilizer_Bar_Bushings: 0,
    Stabilizer_bar: 0,
    templets: 0,
    Cardan: 0,
    crosspieces: 0,
    brake_discs_pads: 0,
    Muffler: 0,
    Exhaust: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'BC', data: infoBottomComponent });
  });

  const handleForm = ({ target }) => {
    const tmpBottomComponent = { ...infoBottomComponent, [target.name]: target.value }
    setInfoCompBottom(tmpBottomComponent);
    autosave.schedule();
  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get( `/peritaje/infostate/C` ,  {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data;
      const currentDefaultState = stateapp.find((e)=> e.name.toLowerCase()==='bueno')
      setInfoCompBottom({
        Axle_Dust_Covers: currentDefaultState.id,
        Axial_Dust_Covers: currentDefaultState.id,
        Scissors: currentDefaultState.id,
        Scissor_Bushings: currentDefaultState.id,
        Stabilizer_Bar_Bushings: currentDefaultState.id,
        Stabilizer_bar: currentDefaultState.id,
        templets: currentDefaultState.id,
        Cardan: currentDefaultState.id,
        crosspieces: currentDefaultState.id,
        brake_discs_pads: currentDefaultState.id,
        Muffler: currentDefaultState.id,
        Exhaust: currentDefaultState.id,
      })
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = {type:'BC', data :infoBottomComponent};
    const respo = await post('/peritaje/modifyinspection/components/'+id, body);
    if(respo.success){
      setMsgButton('Actualizar')
    }
  };
  
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'BC' };
      const tmpBottom = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const {detail} = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpBottom[element.name] = element.id_state;
        }
        if(detail.length>0) setInfoCompBottom(tmpBottom);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner />  : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">COMPONENTES INFERIORES</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Axle_Dust_Covers">Guardapolvos Ejes</Form.Label>
          <Form.Select
            name="Axle_Dust_Covers"
            value={infoBottomComponent.Axle_Dust_Covers}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Axial_Dust_Covers">Guardapolvos Axiales</Form.Label>
          <Form.Select
            name="Axial_Dust_Covers"
            value={infoBottomComponent.Axial_Dust_Covers}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Scissors">Tijeras</Form.Label>
          <Form.Select
            name="Scissors"
            value={infoBottomComponent.Scissors}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Scissor_Bushings">Bujes Tijeras</Form.Label>
          <Form.Select
            name="Scissor_Bushings"
            value={infoBottomComponent.Scissor_Bushings}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Stabilizer_Bar_Bushings">Bujes Barra Estabilizadora</Form.Label>
          <Form.Select
            name="Stabilizer_Bar_Bushings"
            value={infoBottomComponent.Stabilizer_Bar_Bushings}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Stabilizer_bar">Barra Estabilizadora</Form.Label>
          <Form.Select
            name="Stabilizer_bar"
            value={infoBottomComponent.Stabilizer_bar}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="templets">Templetes</Form.Label>
          <Form.Select
            name="templets"
            value={infoBottomComponent.templets}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Cardan">Cardan</Form.Label>
          <Form.Select
            name="Cardan"
            value={infoBottomComponent.Cardan}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="crosspieces">Crucetas</Form.Label>
          <Form.Select
            name="crosspieces"
            value={infoBottomComponent.crosspieces}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="brake_discs_pads">Discos de freno/pastillas</Form.Label>
          <Form.Select
            name="brake_discs_pads"
            value={infoBottomComponent.brake_discs_pads}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Muffler">Silenciador</Form.Label>
          <Form.Select
            name="Muffler"
            value={infoBottomComponent.Muffler}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Exhaust">Escape</Form.Label>
          <Form.Select
            name="Exhaust"
            value={infoBottomComponent.Exhaust}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompBottom;
